export const signByFacsimile = () => {
  return [
    { text: '     22. SIGN BY FACSIMILE', bold: true, style: 'p', },

    { text: "     The parties agree that this TICA may be signed by facsimile and that each fully executed facsimile copy shall be deemed a binding and enforceable original copy hereof.", style: 'p' },
  ]
}